<template>
  <div class="sub-date-picker">
    <div :class="pickerOpen ? 'sub-date-card open' : 'sub-date-card'" @click="togglePicker">
      <div class="sub-date-main">
        <svg width="15" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M31.5 3H30V1.5C30 0.675 29.325 0 28.5 0C27.675 0 27 0.675 27 1.5V3H9V1.5C9 0.675 8.325 0 7.5 0C6.675 0 6 0.675 6 1.5V3H4.5C2.025 3 0 5.025 0 7.5V31.5C0 33.975 2.025 36 4.5 36H31.5C33.975 36 36 33.975 36 31.5V7.5C36 5.025 33.975 3 31.5 3ZM33 31.5C33 32.325 32.325 33 31.5 33H4.5C3.675 33 3 32.325 3 31.5V7.5C3 6.675 3.675 6 4.5 6H6V7.5C6 8.325 6.675 9 7.5 9C8.325 9 9 8.325 9 7.5V6H27V7.5C27 8.325 27.675 9 28.5 9C29.325 9 30 8.325 30 7.5V6H31.5C32.325 6 33 6.675 33 7.5V31.5Z" fill="black"/>
          <path d="M28.5 13.5H7.5C6.675 13.5 6 14.175 6 15C6 15.825 6.675 16.5 7.5 16.5H28.5C29.325 16.5 30 15.825 30 15C30 14.175 29.325 13.5 28.5 13.5Z" fill="black"/>
        </svg>
        <div class="sub-date-details">
          <div class="sub-date-title"><strong>{{ selectedLabel }}</strong></div>
          <div class="sub-date-value">{{ formattedDateRange }}</div>
        </div>
      </div>
      <div class="sub-date-filter" v-show="!pickerOpen">
        <svg width="16" viewBox="0 0 54 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="54" height="6" rx="3" fill="black"/>
          <rect x="6" y="18" width="42" height="6" rx="3" fill="black"/>
          <rect x="15" y="36" width="24" height="6" rx="3" fill="black"/>
        </svg>
      </div>
    </div>

    <div class="sub-date-options" v-show="pickerOpen">
      <a href="javascript:void(0)" :class="optionClass('all')" @click="selectDate('all')">All</a>
      <a href="javascript:void(0)" :class="optionClass('last-week')" @click="selectDate('last-week')">Last 7 days</a>
      <a href="javascript:void(0)" :class="optionClass('this-month')" @click="selectDate('this-month')">This month</a>
      <a href="javascript:void(0)" :class="optionClass('last-month')" @click="selectDate('last-month')">Last month</a>
      <a href="javascript:void(0)" :class="optionClass('last-three-month')" @click="selectDate('last-three-month')">Last 90 days</a>
      <a href="javascript:void(0)" :class="optionClass('this-year')" @click="selectDate('this-year')">This year</a>
    </div>
    <div class="sub-date-layer" v-show="pickerOpen" @click="togglePicker"></div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "SubscriptionDatePicker",
  props: {
    value: {
      type: Object,
      default: () => ({ tenure: "all", from_date: "", to_date: "" }),
    },
  },
  data() {
    return {
      pickerOpen: false,
      selectedDate: {
        tenure: "all",
        from_date: "",
        to_date: "",
      },
    };
  },
  computed: {
    selectedLabel() {
      const map = {
        all: "All",
        "last-week": "Last 7 Days",
        "this-month": "This Month",
        "last-month": "Last Month",
        "last-three-month": "Last 90 Days",
        "this-year": "This Year",
      };
      return map[this.selectedDate.tenure] || "All";
    },
    formattedDateRange() {
      if (!this.selectedDate.from_date || !this.selectedDate.to_date) {
        return "All dates";
      }
      return `${moment(this.selectedDate.from_date).format("MMM D, YYYY")} - ${moment(this.selectedDate.to_date).format("MMM D, YYYY")}`;
    },
  },
  mounted() {
    if (this.value) {
      this.selectedDate = {
        tenure: this.value.tenure || "all",
        from_date: this.value.from_date || "",
        to_date: this.value.to_date || "",
      };
    }
  },
  methods: {
    optionClass(tenure) {
      return this.selectedDate.tenure === tenure ? "sub-date-option active" : "sub-date-option";
    },
    togglePicker() {
      const app = document.getElementById("nav-drawer");
      if (this.pickerOpen) {
        if (app) app.setAttribute("style", "overflow-y:scroll !important");
        this.pickerOpen = false;
      } else {
        if (app) app.setAttribute("style", "overflow-y:hidden !important");
        this.pickerOpen = true;
      }
    },
    selectDate(tenure) {
      this.selectedDate.tenure = tenure;
      if (tenure === "all") {
        this.selectedDate.from_date = "";
        this.selectedDate.to_date = "";
      } else if (tenure === "last-week") {
        this.selectedDate.from_date = moment().subtract(6, "d").format("YYYY-MM-DD");
        this.selectedDate.to_date = moment().format("YYYY-MM-DD");
      } else if (tenure === "this-month") {
        this.selectedDate.from_date = moment().startOf("month").format("YYYY-MM-DD");
        this.selectedDate.to_date = moment().endOf("month").format("YYYY-MM-DD");
      } else if (tenure === "last-month") {
        this.selectedDate.from_date = moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD");
        this.selectedDate.to_date = moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD");
      } else if (tenure === "last-three-month") {
        this.selectedDate.from_date = moment().subtract(89, "d").format("YYYY-MM-DD");
        this.selectedDate.to_date = moment().format("YYYY-MM-DD");
      } else if (tenure === "this-year") {
        this.selectedDate.from_date = moment().startOf("year").format("YYYY-MM-DD");
        this.selectedDate.to_date = moment().endOf("year").format("YYYY-MM-DD");
      }

      this.$emit("input", { ...this.selectedDate });
      this.$emit("change", { ...this.selectedDate });
      this.togglePicker();
    },
  },
};
</script>

<style scoped>
.sub-date-picker { position: relative; }
.sub-date-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border: 1px solid #d8e2dc;
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  position: relative;
  z-index: 1001;
}
.sub-date-card.open { border-radius: 10px 10px 0 0; }
.sub-date-main { display: flex; align-items: flex-start; gap: 8px; }
.sub-date-title { font-size: 13px; line-height: 1.1; margin-bottom: 3px; }
.sub-date-value { font-size: 11px; color: #7c8480; font-weight: 600; line-height: 1.1; }
.sub-date-filter {
  border-left: 1px solid #d3dcd7;
  padding-left: 9px;
  display: flex;
  align-items: center;
}
.sub-date-options {
  position: absolute;
  width: 100%;
  background: #fff;
  border: 1px solid #d8e2dc;
  border-top: 0;
  border-radius: 0 0 10px 10px;
  z-index: 1001;
  padding: 8px 0;
}
.sub-date-option {
  display: block;
  color: #000 !important;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700;
  padding: 8px 14px;
}
.sub-date-option.active {
  background: #eff4f0;
  color: #128c3e !important;
}
.sub-date-layer {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.35);
}
</style>
